module.exports = __webpack_public_path__ + "media/images/lb/700-523119b6efb33549d990f94ab6ba0475.svg";